/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUnStake.vue?vue&type=template&id=1341bd38"
import script from "./popUnStake.vue?vue&type=script&lang=js"
export * from "./popUnStake.vue?vue&type=script&lang=js"
import style0 from "./popUnStake.vue?vue&type=style&index=0&id=1341bd38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports